"use client"
import { Component } from "react"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import "./styles.css"
import Colors from "../../common/Colors"
import routes from "../../routes/URL"
import { Box, Container, Typography, TextField, Button, InputAdornment, Card, CardContent } from "@mui/material"
import { Email, Phone, Person, Refresh, ArrowForward } from "@mui/icons-material"
import Toast from "../../components/Toast"

const errors = {
  uname: "invalid username",
  pass: "invalid mobile",
}

class LoginScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      isLoaded: false,
      active: "login",
      otp: "",
      email: "",
      mobile: "",
      name: "",
      user_id: "dd5a0f90-cef8-42d8-aebb-b9dabde9537e",
      user_type: "hotel",
      sendingOTP: false,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  componentDidMount() {
    const token = localStorage.getItem("token")
    if (token && this.props.isAuth) {
      this.props.history.push(routes.admin.dashboard)
    }
  }

  sendOTP = async (event) => {
    event.preventDefault()
    const fd = {
      user_type: "hotel",
    }
    const emailPhone = event.target.email.value
    if (emailPhone.includes("@")) {
      fd.check_for = "email"
      fd.email = emailPhone
    } else {
      fd.check_for = "mobile"
      fd.mobile = emailPhone
    }

    const { status, message, data } = await API(this, "post", URL_PATH.login, fd)
    if (status == "error") {
      return this.showToast(message, "error")
    } else if (status == "redirect") {
      window.location.href = data
      return
    } else if (status == "success") {
      const { otp_length, name, email, mobile, token, message, signup = false, emailDisabled, mobileDisabled } = data
      this.setState({
        name,
        otp_length,
        token,
        otpMessage: message,
        signup,
        active: "verify",
        email,
        mobile,
        emailDisabled,
        mobileDisabled,
      })
      return
    }
    return this.showToast("Something went wrong", "error")
  }

  handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData(event.target)
    formData.append("user_type", "hotel")
    try {
      const result = await API(this, "post", URL_PATH.verify_otp, formData)
      console.log("API Response:", result)
      if (result?.status === "error") {
        this.showToast(result.message || "Verification failed", "error")
        return
      }
      if (result?.status === "success" || result?.success === true) {
        const { otp_length, token, message, signup = false } = result.data || {}
        this.setState({ otp_length, token, otpMessage: message, signup })
        if (token) {
          window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
        }
        if (result.data?.user?.id) {
          window.axios.defaults.headers.common["userId"] = `${result.data.user.id}`
        }
        if (result.data?.user_type) {
          window.axios.defaults.headers.common["user-type"] = `${result.data.user_type}`
        }
        await this.loginSuccess(result.data)
        return
      }
      console.warn("Unexpected API response format:", result)
      this.showToast("OTP is incorrect.", "error")
    } catch (error) {
      console.error("API Call Failed:", error)
      this.showToast("Failed to verify OTP. Please try again.", "error")
    }
  }

  // loginSuccess = async (data) => {
  //   localStorage.setItem("token", data.token)
  //   localStorage.setItem("user", JSON.stringify(data.user))
  //   localStorage.setItem("user_type", data.user_type)
  //   this.props.setAccessControl(data.access_control)
  //   this.props.setSubscriptionActive(data.subscription_active)
  //   this.props.setAuth(true)
  //   this.props.setUser(data.user)

  //   try {
  //     if (window.OneSignal && data.user?.id) {
  //       // Wait for OneSignal to be fully initialized
  //       await this.waitForOneSignalInit()

  //       console.log("🔐 Setting OneSignal external user ID:", data.user.id)

  //       // Set external user ID (this is the key for backend notifications)
  //       await window.OneSignal.login(data.user.id.toString())
  //       console.log("✅ OneSignal login successful for user ID:", data.user.id)

  //       // Add user tags for better targeting
  //       const tags = {
  //         user_id: data.user.id.toString(),
  //         user_type: data.user_type || "hotel",
  //         account_status: data.subscription_active ? "active" : "inactive",
  //         login_time: new Date().toISOString(),
  //         email: data.user.email || "",
  //         mobile: data.user.mobile || "",
  //       }

  //       await window.OneSignal.User.addTags(tags)
  //       console.log("🏷️ OneSignal tags set:", tags)

  //       // Verify the external ID was set correctly
  //       setTimeout(async () => {
  //         try {
  //           const externalId = await window.OneSignal.User.getExternalId()
  //           const subscriptionId = await window.OneSignal.User.PushSubscription.id
  //           console.log("✅ Verified External ID:", externalId)
  //           console.log("✅ Subscription ID:", subscriptionId)

  //           // Store these for debugging
  //           localStorage.setItem("onesignal_external_id", externalId || "")
  //           localStorage.setItem("onesignal_subscription_id", subscriptionId || "")
  //         } catch (error) {
  //           console.error("❌ Error verifying OneSignal IDs:", error)
  //         }
  //       }, 2000)

  //       console.log("🎯 OneSignal user identification completed successfully")
  //     } else {
  //       console.warn("⚠️ OneSignal not available or user ID missing")
  //     }
  //   } catch (error) {
  //     console.error("❌ Error setting OneSignal user identification:", error)
  //   }

  //   this.props.history.push("/dashboard")
  // }


  
  // Helper function to wait for OneSignal initialization
 
loginSuccess = async (data) => {
  // First set all the critical auth data
  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(data.user));
  localStorage.setItem("user_type", data.user_type);
  this.props.setAccessControl(data.access_control);
  this.props.setSubscriptionActive(data.subscription_active);
  this.props.setAuth(true);
  this.props.setUser(data.user);

  // Navigate immediately
  this.props.history.push("/dashboard");

  // Then handle OneSignal initialization in background
  if (window.OneSignal && data.user?.id) {
    try {
      // Wait for OneSignal to be fully initialized
      await this.waitForOneSignalInit();
      await this.initializeOneSignal(data);
    } catch (error) {
      console.error("OneSignal initialization error:", error);
      // Retry after delay if needed
      setTimeout(() => this.initializeOneSignal(data), 2000);
    }
  }
};

// Helper function to wait for OneSignal initialization
waitForOneSignalInit = () => {
  return new Promise((resolve, reject) => {
    if (window.OneSignal && window.OneSignal._isInitialized) {
      resolve();
      return;
    }

    let attempts = 0;
    const maxAttempts = 30; // 3 seconds max wait
    const interval = setInterval(() => {
      attempts++;
      if (window.OneSignal && window.OneSignal._isInitialized) {
        clearInterval(interval);
        resolve();
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        reject(new Error("OneSignal initialization timeout"));
      }
    }, 100);
  });
};

initializeOneSignal = async (data) => {
  try {
    // Check if OneSignal is available
    if (!window.OneSignal || !window.OneSignal.User) {
      console.warn("OneSignal not available");
      return;
    }

    // Set external user ID
    if (window.OneSignal.login) {
      await window.OneSignal.login(data.user.id.toString());
    } else if (window.OneSignal.setExternalUserId) {
      // For newer versions of OneSignal
      await window.OneSignal.setExternalUserId(data.user.id.toString());
    }

    // Add user tags
    const tags = {
      user_id: data.user.id.toString(),
      user_type: data.user_type || "hotel",
      account_status: data.subscription_active ? "active" : "inactive",
      login_time: new Date().toISOString(),
      email: data.user.email || "",
      mobile: data.user.mobile || "",
    };

    if (window.OneSignal.User.addTags) {
      await window.OneSignal.User.addTags(tags);
    } else if (window.OneSignal.sendTags) {
      // For newer versions of OneSignal
      await window.OneSignal.sendTags(tags);
    }

    console.log("OneSignal setup completed successfully");
  } catch (error) {
    console.error("OneSignal setup error:", error);
  }
};

// Separate method for OneSignal initialization
initializeOneSignal = async (data) => {
  try {
    // Set external user ID
    await window.OneSignal.login(data.user.id.toString())
    
    // Add user tags
    const tags = {
      user_id: data.user.id.toString(),
      user_type: data.user_type || "hotel",
      account_status: data.subscription_active ? "active" : "inactive",
      login_time: new Date().toISOString(),
      email: data.user.email || "",
      mobile: data.user.mobile || "",
    }
    await window.OneSignal.User.addTags(tags)
    
    // Verify IDs in background
    setTimeout(async () => {
      try {
        const externalId = await window.OneSignal.User.getExternalId()
        const subscriptionId = await window.OneSignal.User.PushSubscription.id
        localStorage.setItem("onesignal_external_id", externalId || "")
        localStorage.setItem("onesignal_subscription_id", subscriptionId || "")
      } catch (error) {
        console.error("OneSignal verification error:", error)
      }
    }, 2000)
  } catch (error) {
    console.error("OneSignal setup error:", error)
  }
}

  waitForOneSignalInit = () => {
    return new Promise((resolve, reject) => {
      let attempts = 0
      const maxAttempts = 50 // 5 seconds max wait

      const checkInit = () => {
        if (window.OneSignal && window.OneSignal._initialized) {
          resolve()
        } else if (attempts < maxAttempts) {
          attempts++
          setTimeout(checkInit, 100)
        } else {
          reject(new Error("OneSignal initialization timeout"))
        }
      }

      checkInit()
    })
  }

  renderErrorMessage = (name) => {
    return <div className="error-message">{errors[name]}</div>
  }

  LoginBox() {
    return (
      <form onSubmit={(e) => this.sendOTP(e)} id="login-form">
        <TextField
          fullWidth
          name="email"
          label="Email / Mobile"
          placeholder="Enter Your Mobile Number or Email"
          variant="outlined"
          margin="normal"
          value={this.state.email}
          onChange={(e) => this.setState({ email: e.target.value })}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          endIcon={<ArrowForward />}
          sx={{
            mt: 1,
            mb: 2,
            backgroundColor: Colors.primary,
            color: "black",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: Colors.primary,
              opacity: 0.9,
            },
          }}
        >
          Continue
        </Button>
      </form>
    )
  }

  SignUpBox() {
    return (
      <form onSubmit={(e) => this.handleSubmit(e)} id="login-form">
        <TextField
          fullWidth
          name="name"
          label="Name"
          variant="outlined"
          margin="normal"
          value={this.state.name}
          onChange={(e) => this.setState({ name: e.target.value })}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />
        <TextField
          fullWidth
          name="email"
          label="Email (username)"
          variant="outlined"
          margin="normal"
          value={this.state.email}
          onChange={(e) => this.setState({ email: e.target.value })}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Email sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 2,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />
        <TextField
          fullWidth
          name="mobile"
          label="Mobile Number"
          variant="outlined"
          margin="normal"
          value={this.state.mobile}
          onChange={(e) => this.setState({ mobile: e.target.value })}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Phone sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { color: "white" },
          }}
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.3)",
              },
              "&:hover fieldset": {
                borderColor: "white",
              },
              "&.Mui-focused fieldset": {
                borderColor: Colors.primary,
              },
              color: "white",
            },
          }}
        />
        <input type="hidden" name="user_type" value="hotel" />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          endIcon={<ArrowForward />}
          sx={{
            mt: 1,
            mb: 2,
            backgroundColor: Colors.primary,
            color: "black",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: Colors.primary,
              opacity: 0.9,
            },
          }}
        >
          Submit
        </Button>
      </form>
    )
  }

  VerifyBox() {
    const {
      otp_length,
      token,
      otp,
      otpMessage,
      signup = false,
      emailDisabled = false,
      mobileDisabled = false,
      sendingOTP,
    } = this.state

    return (
      <form onSubmit={(e) => this.handleSubmit(e)} id="login-form">
        <input type="hidden" name="key" value={token} />
        <Box sx={{ mb: 3, mt: 2 }}>
          <Typography variant="body1" sx={{ color: "white", mb: 2, mt: 2 }}>
            {otpMessage}
          </Typography>
          <TextField
            fullWidth
            name="otp"
            label="Verification Code"
            variant="outlined"
            type="number"
            inputProps={{
              maxLength: otp_length,
              minLength: otp_length,
            }}
            value={otp}
            onChange={(e) => this.setState({ otp: e.target.value })}
            InputLabelProps={{
              style: { color: "white" },
            }}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(255, 255, 255, 0.3)",
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                "&.Mui-focused fieldset": {
                  borderColor: Colors.primary,
                },
                color: "white",
              },
            }}
          />
          <Button
            variant="text"
            startIcon={<Refresh />}
            disabled={sendingOTP}
            onClick={async () => {
              console.log("otp button click")
              this.setState({ sendingOTP: true, otp: "" })
              const result = await API(this, "post", URL_PATH.resendOtp, { key: token })
              const { status, data, message } = result
              if (status == "success") {
                this.setState({
                  token: data.token,
                  sendingOTP: false,
                })
              } else {
                this.showToast(message, "error")
                this.setState({ sendingOTP: false })
              }
            }}
            sx={{
              color: Colors.primary,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.05)",
              },
            }}
          >
            Resend OTP
          </Button>
        </Box>
        {signup == false && (
          <>
            <TextField
              fullWidth
              name="name"
              label="Name"
              variant="outlined"
              margin="normal"
              value={this.state.name}
              onChange={(e) => this.setState({ name: e.target.value })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person sx={{ color: "white" }} />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: { color: "white" },
              }}
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.3)",
                  },
                  "&:hover fieldset": {
                    borderColor: "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: Colors.primary,
                  },
                  color: "white",
                },
              }}
            />
            <TextField
              fullWidth
              name="email"
              label="Email"
              variant="outlined"
              margin="normal"
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.target.value })}
              disabled={emailDisabled}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email sx={{ color: emailDisabled ? "gray" : "white" }} />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: { color: emailDisabled ? "gray" : "white" },
              }}
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.3)",
                  },
                  "&:hover fieldset": {
                    borderColor: emailDisabled ? "gray" : "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: emailDisabled ? "gray" : Colors.primary,
                  },
                  color: emailDisabled ? "gray" : "white",
                },
              }}
            />
            <TextField
              fullWidth
              name="mobile"
              label="Mobile Number"
              variant="outlined"
              margin="normal"
              value={this.state.mobile}
              onChange={(e) => this.setState({ mobile: e.target.value })}
              disabled={mobileDisabled}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone sx={{ color: mobileDisabled ? "gray" : "white" }} />
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: { color: mobileDisabled ? "gray" : "white" },
              }}
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.3)",
                  },
                  "&:hover fieldset": {
                    borderColor: mobileDisabled ? "gray" : "white",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: mobileDisabled ? "gray" : Colors.primary,
                  },
                  color: mobileDisabled ? "gray" : "white",
                },
              }}
            />
            <input type="hidden" name="user_type" value="hotel" />
          </>
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          endIcon={<ArrowForward />}
          sx={{
            mt: 1,
            mb: 2,
            backgroundColor: Colors.primary,
            color: "black",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: Colors.primary,
              opacity: 0.9,
            },
          }}
        >
          Continue
        </Button>
      </form>
    )
  }

  RenderBox() {
    if (this.state.active == "login") return this.LoginBox()
    if (this.state.active == "signup") return this.SignUpBox()
    if (this.state.active == "verify") return this.VerifyBox()
  }

  render() {
    return (
      <div className="login-screen">
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />
        <Container
          maxWidth="sm"
          sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <Card
            elevation={8}
            sx={{
              backgroundColor: "transparent",
              backgroundImage: "none",
              border: "1px solid #FFC857",
              borderRadius: "5px",
              width: "100%",
              maxWidth: { xs: "100%", sm: "450px" },
              overflow: "visible",
            }}
          >
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
              <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
                <img src="/logo2.png" alt="logo" className="logo" width="150" />
              </Box>
              {this.RenderBox()}
              {this.state.active == "verify" && (
                <Box sx={{ mt: 3, textAlign: "center" }}>
                  <Typography variant="body2" sx={{ color: "white", mb: 1 }}>
                    {this.state.active == "login"
                      ? "Don't have an account"
                      : this.state.active == "signup"
                        ? "Already have an account"
                        : "Login With another Account"}
                  </Typography>
                  <Typography
                    variant="body2"
                    onClick={() => {
                      this.setState({
                        active:
                          this.state.active == "login" ? "signup" : this.state.active == "signup" ? "login" : "login",
                      })
                    }}
                    sx={{
                      color: Colors.primary,
                      cursor: "pointer",
                      fontWeight: "medium",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {this.state.active == "login"
                      ? "Register"
                      : this.state.active == "signup"
                        ? "Login"
                        : "Back to Login"}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Container>
        <Box
          sx={{
            textAlign: "center",
            mt: 4,
            pt: 2,
            borderTop: "1px solid #333",
          }}
        >
          <Typography variant="body2" sx={{ color: "#9ca3af", fontSize: "14px", mb: 1 }}>
            By Continuing, you agree to our
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <a
              href="https://etable.co.in/about-etable/"
              style={{
                textDecoration: "none",
                fontSize: "14px",
                color: Colors.primary,
              }}
            >
              About Us
            </a>
            <a
              href="https://etable.co.in/contact-us/"
              style={{
                textDecoration: "none",
                fontSize: "14px",
                color: Colors.primary,
              }}
            >
              Contact Us
            </a>
            <a
              href="https://etable.co.in/terms-conditions/"
              style={{
                textDecoration: "none",
                fontSize: "14px",
                color: Colors.primary,
              }}
            >
              Terms and Conditions
            </a>
            <a
              href="https://etable.co.in/privacy-policy-2/"
              style={{
                textDecoration: "none",
                fontSize: "14px",
                color: Colors.primary,
              }}
            >
              Privacy Policy
            </a>
            <a
              href="https://etable.co.in/refund-cancellation-policy/"
              style={{
                textDecoration: "none",
                fontSize: "14px",
                color: Colors.primary,
              }}
            >
              Refund Policy
            </a>
            <a
              href="https://etable.co.in/"
              style={{
                textDecoration: "none",
                fontSize: "14px",
                color: Colors.primary,
              }}
            >
              Etable Website
            </a>
          </Box>
        </Box>
      </div>
    )
  }
}

export default redux(LoginScreen)
